import { Divider } from '@advanza/ui'
import ExpectationSettingsList from 'components/expectationsettings/ExpectationSettingsList'
import Page from 'components/ui/Page'

const ExpectationSettingsPage = () => (
    <Page title="Expectation settings">
        <Divider />
        <ExpectationSettingsList />
        <Divider xxxl />
    </Page>
)

export default ExpectationSettingsPage
